import { Social_Tag, Social_Tag_Type_Enum, Tag_Rule } from '@kheops/graphql';
import { ProductHit, SupplierHit } from '../../search/search';

export type SocialTag = Pick<Social_Tag, 'type' | 'level' | 'priority'>;

export function extractSocialTagsFromDiscoveryHit(hit: ProductHit | SupplierHit): SocialTag[] {
  const socialTags: string[] = (hit.social_tags_lvl1 || []).concat(hit.social_tags_lvl2 || []);

  return socialTags.map((tag) => {
    const [type, level, priority] = tag.split('|');

    return {
      type: type as Social_Tag_Type_Enum,
      level: parseInt(level, 10),
      priority: parseInt(priority, 10),
    };
  });
}

export function getSocialTagFromTagRule(tagRule: Pick<Tag_Rule, 'tag_type' | 'rule'>): SocialTag {
  return {
    type: tagRule.tag_type,
    level: tagRule.rule!.event.params.level,
    priority: tagRule.rule!.event.params.priority,
  };
}
